const localizeAirportNames = (airports, locations) => {
  return airports?.map((airport) => {
    const location = locations?.find(
      (location) =>
        location?.airport_code === airport?.fs ||
        location?.airports?.find((item) => item?.code === airport?.fs)
    );

    if (location)
      return {
        ...airport,
        city: location?.city_name,
        countryName: location?.country_name,
      };
    else return airport;
  });
};

export default localizeAirportNames;
